var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Swiper',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.$route.name != 'ProjectDetails' && _vm.$route.name != 'ContentDetails'
    ),expression:"\n      $route.name != 'ProjectDetails' && $route.name != 'ContentDetails'\n    "}]}),_c('router-view',{key:_vm.key}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }